'use client'

import { useState } from 'react'

import { formatDate } from '@/shared/lib'
import { ContentBox, Icon } from '@/shared/ui'

import { GuestPayDeadlineDialog } from './guest-pay-deadline-dialog'

type Props = {
  payDeadlineTime: string
}

export const GuestPayDeadline = ({ payDeadlineTime }: Props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const formattedDeadline = formatDate({
    date: payDeadlineTime,
    format: 'yyyy년 M월 d일 a h:mm',
  })

  const handleOpenDialog = () => {
    setIsDialogOpen(true)
  }

  const handleOpenChange = (open?: boolean) => {
    setIsDialogOpen(open || false)
  }

  return (
    <>
      <GuestPayDeadlineDialog
        isOpen={isDialogOpen}
        onOpenChange={handleOpenChange}
      />
      <ContentBox
        color="light-gray"
        align="center"
        className="mx-10 flex-col items-center gap-1 py-3"
      >
        <div className="flex items-center gap-1">
          <span className="typo-label1 font-medium text-black">
            게스트 결제 마감 시한
          </span>
          <button className="cursor-pointer" onClick={handleOpenDialog}>
            <Icon size={18} name="info-lined" className="text-gray-500" />
            <span className="sr-only">결제 마감 시한 안내 보기</span>
          </button>
        </div>
        <span className="typo-label1 font-semibold text-purple-500">
          {formattedDeadline}
        </span>
      </ContentBox>
    </>
  )
}
